export const START_LOADER = 'START_LOADER'
export const STOP_LOADER = 'STOP_LOADER'

export const ACCOUNT_LOAD = 'ACCOUNT_LOAD'
export const LOGOUT_ACCOUNT = 'LOGOUT_ACCOUNT'
export const ACCOUNT_LOGIN_REQUEST = 'ACCOUNT_LOGIN_REQUEST'
export const ACCOUNT_LOGIN_REQUEST_SUCCESS = 'ACCOUNT_LOGIN_REQUEST_SUCCESS'
export const ACCOUNT_LOGIN_REQUEST_FAIL = 'ACCOUNT_LOGIN_REQUEST_FAIL'

export const UPDATE_PROFILE = 'UPDATE_PROFILE'

export const NEW_NOTIFICATION = 'NEW_NOTIFICATION'
export const READ_ALL_NOTIFICATIONS = 'READ_ALL_NOTIFICATIONS'
export const READ_NOTIFICATION = 'READ_NOTIFICATION' 